"use client";

import { useState, type SubmitEvent } from "react";

// Render the public 'recuperar senha' form that notifica o administrador.
export function RecuperarSenhaForm() {
  const [login, setLogin] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Envia o pedido para o endpoint de recuperação em português.
  async function handleSubmit(event: SubmitEvent<HTMLFormElement>) {
    event.preventDefault();
    setIsSubmitting(true);
    setMessage(null);

    try {
      const response = await fetch("/api/auth/recuperar-senha", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ login }),
      });

      const payload = (await response.json().catch(() => null)) as { ok?: boolean; message?: string } | null;

      if (!response.ok || !payload?.ok) {
        setMessage(payload?.message ?? "Não foi possível enviar a solicitação. Tente novamente.");
        return;
      }

      setMessage("Solicitação enviada. O administrador será notificado por e-mail.");
      setLogin("");
    } catch {
      setMessage("Erro inesperado ao enviar a solicitação. Tente novamente.");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <section className="rounded-3xl border border-blue-900/10 bg-[linear-gradient(180deg,rgba(255,255,255,0.97),rgba(235,243,252,0.99))] p-6 shadow-[0_18px_45px_rgba(15,23,42,0.08)] sm:p-8">
      <p className="text-sm font-semibold uppercase tracking-[0.22em] text-blue-700">Sistech Sistemas</p>
      <h1 className="mt-3 text-3xl font-semibold tracking-tight text-blue-950 sm:text-4xl">Recuperar senha</h1>
      <p className="mt-4 max-w-3xl text-base leading-7 text-slate-700 sm:text-lg">Informe o seu nome de usuário para notificar o administrador sobre a solicitação de recuperação.</p>

      <form className="mt-8 space-y-5" onSubmit={handleSubmit} noValidate>
        <div>
          <label htmlFor="login" className="text-sm font-medium text-blue-950">
            Nome de usuário
          </label>
          <input
            id="login"
            name="login"
            type="text"
            className="mt-2 w-full rounded-2xl border border-blue-900/15 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-blue-600 focus:ring-2 focus:ring-blue-300/60"
            value={login}
            onChange={(event) => setLogin(event.target.value)}
            autoComplete="username"
            required
          />
        </div>

        {message ? (
          <p className="rounded-2xl border border-blue-900/10 bg-white px-4 py-3 text-sm text-blue-900" role="status" aria-live="polite">
            {message}
          </p>
        ) : null}

        <button
          type="submit"
          className="inline-flex rounded-full bg-[linear-gradient(135deg,#12356d,#2563eb)] px-5 py-3 text-sm font-semibold text-white shadow-md shadow-blue-950/15 transition-colors hover:brightness-110 disabled:cursor-not-allowed disabled:opacity-75"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Enviando..." : "Enviar email de recuperação"}
        </button>
      </form>
    </section>
  );
}
